const BaseComponent = require('base/base-component');
const Util = require('helper/util');

class HeaderNav extends BaseComponent {
  init () {
    if (!Util.isIE(8)) {
      this.$el.find('.js-head-menu').lavalamp({
        easing: 'easeOutBack'
      });
    }
  }
}
module.exports = HeaderNav;
